import { connect } from 'react-redux';
import Component from './component';
import { push } from 'react-router-redux/lib/actions';
import clubAction from '../../../actions/club';

export default connect(
  state => ({
    loading: state.club.loading
  }),
  dispatch => ({
    save: (model) => dispatch(clubAction.save(model)),
    goIndex: () => dispatch(push('/clubs'))
  })
)(Component);




// WEBPACK FOOTER //
// ./src/components/Clubs/ClubEdit/index.js